.mainScreen {
  color: #231e19;
  position: relative;

  .icon {
    position: absolute;
  }
  .icon:nth-child(1) {
    left: 0;
    width: 64px;
    top: 38%;
  }
  .icon:nth-child(2) {
    left: 17%;
    width: 63px;
    bottom: 20%;
  }
  .icon:nth-child(3) {
    right: 0;
    width: 84px;
    bottom: 6%;
  }

  img {
    width: 100%;
  }
}

.title {
  text-align: center;
  font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif;
  font-size: 34px;
  font-weight: 800;
  line-height: 41px;
  letter-spacing: -0.4px;
  padding: 0 20px;
}

// Dark mode
:global body.dark {
  :local {
    .mainScreen {
      color: #fffbf2;
    }

    .icon:nth-child(2) {
      display: none;
    }
  }
}
